import { BelpostContact } from '$shared/types';
import { AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';

export function recipientCashOnDeliveryValidator(
  group: FormGroup
): ValidationErrors | null {
  const recipientControl = group.get(
    'recipient'
  ) as AbstractControl<BelpostContact | null>;
  const cashOnDeliveryControl = group.get('cash_on_delivery');

  if (
    cashOnDeliveryControl?.enabled &&
    cashOnDeliveryControl?.value &&
    recipientControl?.value?.person?.type === 'legal'
  ) {
    recipientControl.setErrors([
      'BATCH_MAILING.BATCHES_TAB.CREATE_TABLE.VALIDATON_LEGAL',
    ]);
    cashOnDeliveryControl.setErrors([
      'BATCH_MAILING.BATCHES_TAB.CREATE_TABLE.VALIDATON_LEGAL',
    ]);

    return { error: true };
  }

  if (recipientControl) {
    recipientControl.setErrors(null);
  }

  if (cashOnDeliveryControl) {
    cashOnDeliveryControl.setErrors(null);
  }

  return null;
}
